import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { Subject, takeUntil } from 'rxjs';

import { ValidationConstants, ValidationService } from 'sc-common';
import { ApiPaperCopyrightSubmit, WorkOwnerEnum } from 'sc-common/core/services/open-api/main-api-client';

@Component({
    selector: 'et-paper-copyright-form',
    templateUrl: './paper-copyright-form.component.html',
    styleUrls: ['./paper-copyright-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PaperCopyrightFormComponent implements OnInit, OnDestroy {

    @Input()
    public copyrightText: string;

    @Input()
    public requestInProcess: boolean;

    @Input()
    public isReadonly: boolean;

    @Output()
    public readonly copyrightSubmitted = new EventEmitter<ApiPaperCopyrightSubmit>();

    public workOwnerEnum = WorkOwnerEnum;

    public form: UntypedFormGroup;

    private readonly _destroy$ = new Subject<void>();

    constructor(private readonly _formBuilder: UntypedFormBuilder) {
    }

    public ngOnInit(): void {
        this.form = this._buildForm();
    }

    public ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    public get isOrganization(): boolean {
        const workOwner = this.form.get('workOwner').value;
        return workOwner === WorkOwnerEnum.Government || workOwner === WorkOwnerEnum.HiredEmployee;
    }

    public submitForm(): void {

        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        this.copyrightSubmitted.emit(this.form.value);
    }

    private _buildForm(): UntypedFormGroup {

        const form = this._formBuilder.group({
            workOwner: [{ value: null, disabled: this.isReadonly }, Validators.required],
            organization: ['', [
                ValidationService.alphaNumSymbolValidator,
                Validators.maxLength(ValidationConstants.Max200Length)]],
            confirmed: [{ value: false, disabled: this.isReadonly }, Validators.requiredTrue]
        });

        const organizationControl = form.get('organization');

        form.get('workOwner').valueChanges
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
                if (this.isOrganization) {
                    organizationControl.addValidators(Validators.required);
                } else {
                    organizationControl.removeValidators(Validators.required);
                }

                organizationControl.updateValueAndValidity();
            });

        return form;
    }
}
